import React from 'react'

const KAMOperatorGroup = ({
  operatorName,
  operatorColor,
  bgLight,
  borderColor,
  textColor,
  kamCount,
  totalGoal,
  totalGoalTarget,
  totalSales,
  unassignedSales = 0,
  achievementPercent,
  colSpan = 13
}) => {
  return (
    <tr className={`${bgLight} border-t-2 ${borderColor}`}>
      <td colSpan={colSpan} className="px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <i className={`fa-solid fa-circle ${textColor} fa-lg`}></i>
            <span className="text-base font-bold text-gray-800">{operatorName}</span>
            <span className="text-sm text-gray-600">
              ({kamCount} KAM{kamCount !== 1 ? '-ów' : ''})
            </span>
          </div>
          <div className="flex items-center space-x-6 text-sm">
            <div>
              <span className="text-gray-500">Cel MIN:</span>{' '}
              <span className="font-semibold text-gray-800">{totalGoal.toLocaleString()}</span>
              {totalGoalTarget > 0 && totalGoalTarget !== totalGoal && (
                <>
                  {' / '}
                  <span className="text-gray-500">TARGET:</span>{' '}
                  <span className="font-semibold text-gray-800">{totalGoalTarget.toLocaleString()}</span>
                </>
              )}
            </div>
            <div>
              <span className="text-gray-500">Łączna sprzedaż KAM-ów:</span>{' '}
              <span className="font-semibold text-gray-800">{totalSales.toLocaleString()}</span>
              {unassignedSales > 0 && (
                <span
                  className="ml-2 text-gray-400 italic"
                  title="Sprzedaż bez KAM-a (WWW / TELE / magazyn centralny) — nie wlicza się do wyników KAM-ów"
                >
                  (+ {unassignedSales.toLocaleString()} nieprzypisane)
                </span>
              )}
            </div>
            <div>
              <span className="text-gray-500">Realizacja:</span>{' '}
              <span className="font-semibold text-amber-600">{achievementPercent.toFixed(1)}%</span>
            </div>
          </div>
        </div>
      </td>
    </tr>
  )
}

export default KAMOperatorGroup


